export default __webpack_public_path__ + "static/media/graph-radio-signs.6b64e478.png";